import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['Mujeres de 50+ que sienten que su metabolismo se "detuvo"', 'Mujeres en pre, peri o postmenopausia sufriendo de inflamación abdominal', 'Quienes buscan una solución natural, sin fármacos ni suplementos caros', 'Personas con poco tiempo que necesitan resultados prácticos y reales'];
const notForYou = ['Quienes buscan una "pastilla mágica" sin cambiar ningún hábito', 'Personas que prefieren entrenamientos de gimnasio de alta intensidad', 'Hombres o mujeres menores de 40 años (sus reglas hormonales son distintas)'];
export function ForWhom() {
  return <section className="py-16 md:py-24 bg-cream" data-id="element-55">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-forest mb-12 text-center" data-id="element-57">
          ¿Es esto para ti?
        </motion.h2>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-58">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-sage-primary/10 rounded-xl p-8" data-id="element-59">
            <h3 className="font-serif text-2xl text-forest mb-6" data-id="element-60">
              Para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-61">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-62">
                  <CheckIcon className="w-6 h-6 text-sage-dark flex-shrink-0 mt-1" data-id="element-63" />
                  <span className="text-forest/80" data-id="element-64">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-forest/5 rounded-xl p-8" data-id="element-65">
            <h3 className="font-serif text-2xl text-forest mb-6" data-id="element-66">
              No es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-67">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-68">
                  <XIcon className="w-6 h-6 text-forest/40 flex-shrink-0 mt-1" data-id="element-69" />
                  <span className="text-forest/60" data-id="element-70">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}